<template>
  <nav>
    <v-card height="552" flat color="rgba(0,0,0,0)" style="border-radius: 10px;" class="pb-">
      <v-card class="card1 ml-3 mr-3 mt-2">
        <v-carousel height="270" hide-delimiters :cycle="false">
          <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item"></v-carousel-item>
        </v-carousel>
      </v-card>
      <v-card class="card2 pl-3 pr-3 pb-2">
        <v-card class="card3" flat>
            <div style="padding-top: 255px; font-size: 18px;">
              
              <v-card class="mt-3 mb-4 ml-1 mr-1" flat style="border-radius: 50px" color="grey lighten-3">
                
                  <v-container fill-height style="padding: 0px; margin: 0px;">
                  <v-avatar size="90" class="">
                    <v-img
                      :src="postUserDetails.avatar"
                    />
                  </v-avatar>
                  <span>
                  <span class="ml-3 font-weight-bold" style="font-size: 16px;">
                    {{ postUserDetails.name }}
                  </span>
                  <br/>
                  <span class="ml-3 font-italic success--text" style="font-size: 16px;">
                    {{ postUserDetails.email }}
                  </span>
                  <br/>
                  <span class="ml-3 success--text" style="font-size: 16px;">
                    {{ postUserDetails.contact }}
                  </span>
                  </span>
                  </v-container>
                
              </v-card>
            </div>

          <center>
            <div style="font-size: 18px;">
              <span class="headline green--text stopflow">{{item_name}}</span>
              <v-divider class="mb-2" />
              <span>Price Marked: </span>
              <span class="green--text font-weight-bold">&#8377;{{marked_price}}</span>
							<br/>
							<span>Category: </span>
							<span class="green--text font-weight-bold">{{category}}</span>
              <br/>
							<span>My Bid: </span>
							<span class="green--text font-weight-bold">&#8377;{{bid}}</span>
            </div>
          </center>

          
        </v-card>
      </v-card>
    </v-card>
  </nav>
</template>
<script>
import firebase from "firebase";

export default {
  props: {
    item_name: String,
    category: String,
    marked_price: Number,
    photos: Array,
    posted_by: Object,
    postId: String,
    bid: Number
  },

  data() {
    return {
      postUserDetails: {}
    };
  },

  mounted(){
    const db = firebase.firestore();
    var vm = this;
    db.collection('users').doc(vm.posted_by.uid).get()
    .then(function(doc){
      vm.postUserDetails = {
        uid: doc.id,
        name: doc.data().name,
        avatar: doc.data().avatar,
        email: doc.data().email,
        contact: doc.data().contact
      }
    })
  }


};
</script>

<style scoped>
.card1 {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  top: 0px;
}
.card2 {
  border-radius: 10px;
  position: relative;
  bottom: 240px;
  z-index: 0;
}
.card3 {
  border-radius: 0px 0px 10px 10px;
  z-index: 0;
}
.scroll {
  overflow-y: auto;
}
.stopflow {
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
</style>